import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import {handleUrlPathVal} from './utils.js'
import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 120000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {

    // request请求entity域
    if(typeof(config.data) != "undefined") { //适用于post,put,delete请求
    	config.data = config.data;
    } else {
    	config.data = {};
    }
    let urlTemp = handleUrlPathVal(config.url,config.data);
    config.url = urlTemp;
		if(config.url.indexOf('/admin/auth/login')<0) {
		  // 让每个请求携带token
		  config.headers['token'] = Cookies.get('token');
		}
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code == 1) { //请求失败
      Message.error(res.message);
      return Promise.reject('error')
    } else if (res.code == 10001) {  //当前为未登录状态
      MessageBox.alert('当前为未登录状态', '错误', {
        confirmButtonText: '确定',
        type: 'error',
        callback:action => {
					Cookies.remove('token');
					localStorage.removeItem('menuName');
					location.href = '/'
        }
      })
    } else if (res.code && res.code != '00000') {
      // 非5xx的错误属于业务错误，留给具体页面处理
      return Promise.resolve(res)
    } else {
      return response
    }
  }, error => {
    Message.error('登录连接超时,请联系系统管理员');
    store.dispatch('FedLogOut').then(() => {
      location.reload()
    })
  }
)

export default service
